<div class="container-fluid mt-2">
  <p-panel header="Update DB" styleClass="p-shadow-3">
    <p-table #dt [columns]="selectedColumns" [columns]="cols" [value]="dados" [rowHover]="true"
      [paginator]="dados?.length > 10" [rows]="10" [showCurrentPageReport]="true" [loading]="loading"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
      currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registro(s)"
      [rowsPerPageOptions]="[10,20,30,50,100]" [autoLayout]="true" sortMode="multiple"
      [globalFilterFields]="['codigo','categoriaItem','status']" paginatorDropdownAppendTo="body">
      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dados?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
            style="padding: 20px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field"
            style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
            [ngStyle]="{'width': col.width}">
            {{col.header}}
            <p-sortIcon [field]="col.field" class="p-sortable-colum"
              *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
            </p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <div *ngIf="col.field != 'status'">
              {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="card" *ngIf="dados?.length === 0">
      <div class="card-body bg-no-records p-shadow-3">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </div>
    </div>
  </p-panel>
</div>
<p-confirmDialog key="tipoItem" [style]="{width: '450px'}"></p-confirmDialog>
<p-toast key="tipoItem" position="bottom-right"></p-toast>
<p-confirmDialog key="categoriaItem" [style]="{width: '450px'}"></p-confirmDialog>
<p-toast key="categoriaItem" position="bottom-right"></p-toast>
